// validation helper for form elements:
export const getValidationError = ({ input, validation }) => {
    for (const rule of validation) {
        if (!rule.isValid(input)) {
            return rule.errorMsg;
        }
    }

    return null;
};
